import { render } from "./ClassmateTable.vue?vue&type=template&id=01052114"
import script from "./ClassmateTable.vue?vue&type=script&lang=js"
export * from "./ClassmateTable.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/h5/luqiao/display/ClassmateTable.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "01052114"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('01052114', __exports__)) {
    api.reload('01052114', __exports__)
  }
  
  module.hot.accept("./ClassmateTable.vue?vue&type=template&id=01052114", () => {
    api.rerender('01052114', render)
  })

}


export default __exports__